module.exports = __webpack_public_path__ + "static/img/dou_question_banner.a4b3276e.png";